import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext } from "react";
import { useInitInvoice } from "hooks/invoice/useInitInvoice";
var InvoiceInitContext = /*#__PURE__*/ createContext(undefined);
export var InvoiceInitProvider = function(param) {
    var children = param.children;
    var contextValue = useInitInvoice();
    return /*#__PURE__*/ _jsx(InvoiceInitContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useInvoiceInitContext = function() {
    var context = useContext(InvoiceInitContext);
    if (!context) {
        throw new Error("useInvoiceInitContext must be used within a InvoiceInitProvider");
    }
    return context;
};
